<template>
    <div class="row vcenter">
      <div class="sm-8">
        <div class="row vcenter">
          <div class="sm-4 md-3 text-center pointer" @click="update('reduce')">
            <i class="material-icons">remove</i>
          </div>
          <!-- <div
            class="sm-4 md-6 text-center p-2 quantity"
            :class="loading ? 'pulse' : null"
          >
            {{ quantity }}
          </div> -->
          <!-- <div class="sm-4 md-6 p-2 text-center quantity"> -->
          <div class="sm-4 md-6 input-field mb-0">
            <input type="text" :value="cartItem.quantity" @keyup="quantityInputUpdate">
          </div>
          <!-- </div> -->
          <div class="sm-4 md-3 text-center pointer" @click="update('add')">
            <i class="material-icons">add</i>
          </div>
        </div>
      </div>
      <div class="sm-4 text-center">
        <!-- <i class="material-icons">favorite_border</i> -->
        <i class="material-icons text-red pointer" @click="update('delete')">close</i>
      </div>
    </div>
</template>

<script>
export default {
  name: "QuantitySelect",
  props: {
    cartItem: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cartUpdateTimeout: null,
    }
  },
  methods: {
    update(method, quantity=0) {
      const product = this.cartItem.product;
      let payload = product;
      let actionName = "";
      this.productToUpdate = product;

      switch (method) {
        case "add":
          actionName = "addCartItem";
          break;
        case "reduce":
          actionName = "removeItem";
          payload = {
            product,
          };
          break;
        case "delete":
          actionName = "removeAllItems";
          break;
        case "updateByNo":
          actionName = "updateCartItemQuantity"
          payload = {
            productId: product.id,
            payload: {
              quantity,
            }
          }
          break;
      }

      this.$store
        .dispatch(`Cart/${actionName}`, payload)
    },
    quantityInputUpdate(e) {
      let val = e.target.value;
      val = e.target.value = val.replace(/\D/g, '')

      if (val) {
        if (this.cartUpdateTimeout)
          clearTimeout(this.cartUpdateTimeout)

        this.cartUpdateTimeout = setTimeout(() => this.update("updateByNo", val), 2000)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.quantity {
  border: 2px solid transparentize($primary-color, 0.3);
  background-color: $grey-light-4;
  border-radius: 5px;
  // height: 50px;
}
</style>
